import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useFirebase } from "../../../context/Firebase";
import Sidebar from "../../../shared/components/Sidebar";
import {
  collection,
  addDoc,
  onSnapshot,
  doc,
  getDoc,
  query,
  orderBy,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { firebaseAuth } from "../../../context/Firebase";
import "./comments.css";
import { formatDistanceToNow } from "date-fns";

const CommentsPage = () => {
  const { postId } = useParams();
  const { db } = useFirebase();
  const [authUser] = useAuthState(firebaseAuth);
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!postId) return;

    const commentRef = collection(db, "posts", postId, "comments");
    const q = query(commentRef, orderBy("createdAt", "asc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const postComments = snapshot.docs.map((doc) => {
          const data = doc.data();

          // Normalize fields for both mobile & web comments
          return {
            id: doc.id,
            // comment text fallback
            text: data.text || data.commentText || "",
            // author fallback: simple string or nested userObject.name
            author: data.author || (data.userObject && data.userObject.name) || "Anonymous",
            // timestamp fallback: Firestore timestamp or JS date or null
            createdAt:
              data.timestamp?.toDate?.() || data.createdAt?.toDate?.() || data.createdAt || null,
          };
        });
        setComments(postComments);
      },
      (error) => {
        console.error("Error fetching comments: ", error);
      }
    );

    return () => unsubscribe();
  }, [db, postId]);

  const submitComment = async (e) => {
    e.preventDefault();
    if (!authUser || !commentInput.trim()) {
      alert("Please login and enter a comment");
      return;
    }

    try {
      const userDoc = await getDoc(doc(db, "users", authUser.uid));
      const user = userDoc.exists() ? userDoc.data() : null;

      // Save comment using mobile compatible schema
      await addDoc(collection(db, "posts", postId, "comments"), {
        commentText: commentInput.trim(),
        userObject: {
          name: user?.name || "Anonymous",
          email: user?.email || "",
          picture: user?.picture || "",
        },
        createdAt: new Date(),
      });

      setCommentInput("");
    } catch (error) {
      console.error("Error adding comment:", error);
      alert("Error adding comment: " + error.message);
    }
  };

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard--content">
        <div className="comments-page">
          <button className="back-button" onClick={() => navigate(-1)}>
            ⬅ Back
          </button>
          <h2>Comments</h2>

          {comments.length === 0 && <p>No comments yet.</p>}

          {comments.map((comment) => (
            <div key={comment.id} className="comment">
              <div className="comment-header">
                <span className="comment-user">{comment.author}</span>
                <span className="comment-time">
                  {comment.createdAt
                    ? formatDistanceToNow(comment.createdAt, { addSuffix: true })
                    : "Just now"}
                </span>
              </div>
              <p>{comment.text}</p>
            </div>
          ))}

          <form onSubmit={submitComment} className="comment-form">
            <textarea
              value={commentInput}
              onChange={(e) => setCommentInput(e.target.value)}
              placeholder="Write your comment..."
              rows="3"
            />
            <button type="submit">Add Comment</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CommentsPage;
